import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "list-view-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M2.25 4C2.25 3.03379 3.03379 2.25 4 2.25H20C20.9662 2.25 21.75 3.03379 21.75 4V6C21.75 6.96621 20.9662 7.75 20 7.75H4C3.03379 7.75 2.25 6.96621 2.25 6V4ZM4 3.75C3.86221 3.75 3.75 3.86221 3.75 4V6C3.75 6.13779 3.86221 6.25 4 6.25H20C20.1378 6.25 20.25 6.13779 20.25 6V4C20.25 3.86221 20.1378 3.75 20 3.75H4Z"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M2.25 11C2.25 10.0338 3.03379 9.25 4 9.25H20C20.9662 9.25 21.75 10.0338 21.75 11V13C21.75 13.9662 20.9662 14.75 20 14.75H4C3.03379 14.75 2.25 13.9662 2.25 13V11ZM4 10.75C3.86221 10.75 3.75 10.8622 3.75 11V13C3.75 13.1378 3.86221 13.25 4 13.25H20C20.1378 13.25 20.25 13.1378 20.25 13V11C20.25 10.8622 20.1378 10.75 20 10.75H4Z"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M4 16.25C3.03379 16.25 2.25 17.0338 2.25 18V20C2.25 20.9662 3.03379 21.75 4 21.75H20C20.9662 21.75 21.75 20.9662 21.75 20V18C21.75 17.0338 20.9662 16.25 20 16.25H4ZM3.75 18C3.75 17.8622 3.86221 17.75 4 17.75H20C20.1378 17.75 20.25 17.8622 20.25 18V20C20.25 20.1378 20.1378 20.25 20 20.25H4C3.86221 20.25 3.75 20.1378 3.75 20V18Z"
    }, null, -1)
  ])))
}
export default { render: render }